/**
 * Orquestador principal de rutas de Mentfull.
 *
 * Responsabilidades:
 * - Montar providers globales de autenticación y notificaciones.
 * - Declarar las rutas públicas, privadas de usuario y privadas de admin.
 * - Inicializar el listener foreground de Firebase Cloud Messaging.
 */
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Login from "./components/Login";
import Register from "./components/Register";
import Dashboard from "./components/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import PrivateRouteAdmin from "./components/PrivateRouteAdmin"; // Importamos la nueva ruta
import Payment from "./components/Payment";
import ReactivateMembership from "./components/ReactivateMembership";
import { AuthProvider } from "./context/AuthContext";
import {
  NotificationProvider,
  useNotification,
} from "./context/NotificationContext";

import "./App.scss";
import Membresias from "./components/Membresias";
import LoginAdmin from "./components/LoginAdmin";
import DashboardAdmin from "./components/DashboardAdmin";
import { initializeOnMessage } from "./firebaseMessaging";

function AppWrapper() {
  const { showNotification } = useNotification();

  useEffect(() => {
    // El listener se registra una sola vez por ciclo de vida del provider.
    if (showNotification) {
      initializeOnMessage(showNotification);
    }
  }, [showNotification]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/membresias" element={<Membresias />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/payment" element={<Payment />} />
        <Route
          path="/dashboard"
          element={<PrivateRoute component={Dashboard} />}
        />
        <Route path="/reactivate" element={<ReactivateMembership />} />
        <Route path="/admin-login" element={<LoginAdmin />} />
        <Route
          path="/dashboard-admin"
          element={<PrivateRouteAdmin component={DashboardAdmin} />}
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppWrapper />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
